// Tek kaynak: desteklenen diller. Dil eklemek/çıkarmak için sadece bu listeyi
// düzenleyin + public/locales/<code>/ altına çeviri dosyalarını ekleyin.
// nativeName = dil seçicide kendi dilinde gösterilen ad.

export interface LocaleDef {
  code: string;
  nativeName: string;
  englishName: string;
  rtl?: boolean;
}

// Türkiye merkezli sınır ötesi taşımacılık için varsayılan 15 dil
// (AB hattı + Kafkasya + Ortadoğu + BDT). Müşteri ihtiyacına göre düzenlenir.
export const SUPPORTED_LOCALES: LocaleDef[] = [
  { code: "tr", nativeName: "Türkçe", englishName: "Turkish" },
  { code: "en", nativeName: "English", englishName: "English" },
  { code: "de", nativeName: "Deutsch", englishName: "German" },
  { code: "ru", nativeName: "Русский", englishName: "Russian" },
  { code: "ar", nativeName: "العربية", englishName: "Arabic", rtl: true },
  { code: "fa", nativeName: "فارسی", englishName: "Persian", rtl: true },
  { code: "fr", nativeName: "Français", englishName: "French" },
  { code: "es", nativeName: "Español", englishName: "Spanish" },
  { code: "it", nativeName: "Italiano", englishName: "Italian" },
  { code: "bg", nativeName: "Български", englishName: "Bulgarian" },
  { code: "ro", nativeName: "Română", englishName: "Romanian" },
  { code: "el", nativeName: "Ελληνικά", englishName: "Greek" },
  { code: "ka", nativeName: "ქართული", englishName: "Georgian" },
  { code: "az", nativeName: "Azərbaycan", englishName: "Azerbaijani" },
  { code: "uk", nativeName: "Українська", englishName: "Ukrainian" },
];

export const SUPPORTED_LANGUAGE_CODES = SUPPORTED_LOCALES.map((l) => l.code);

export const RTL_LANGUAGE_CODES = SUPPORTED_LOCALES.filter((l) => l.rtl).map(
  (l) => l.code,
);

export const DEFAULT_LOCALE = "tr";
export const FALLBACK_LOCALE = "en";

export function isRtl(code: string): boolean {
  return RTL_LANGUAGE_CODES.includes(code.split("-")[0]);
}

export function localeDef(code: string): LocaleDef | undefined {
  const base = code.split("-")[0];
  return SUPPORTED_LOCALES.find((l) => l.code === base);
}
